import { useQuery } from "@tanstack/react-query";

import { auditService } from "@/services/auditService";

export function useAuditLogs(workspaceId: number | null, enabled = true) {
  return useQuery({
    queryKey: ["audit-logs", workspaceId],
    queryFn: () => auditService.list(workspaceId as number, { limit: 100 }),
    enabled: workspaceId != null && enabled,
  });
}
